import React, { useRef } from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import classnames from 'classnames'

import ColorMenu from '../panes/ColorMenu'
import useClickOutside from '../../common/useClickOutside'
import { getDefaultGrayColor } from '../../../utils'

const ColorPicker = ({ selectedId, onClick, dataStore, uiStore, selectionStore, t, hasTransparencyOption, transparency, onTransparencyChange }) => {
  const colorPickerRef = useRef(null)

  useClickOutside(
    colorPickerRef,
    () => uiStore.hideColorsMenu(),
    uiStore.isColorPickerExpanded,
    (uiStore.quickCreate && uiStore.quickCreate.isOpen) ? ['.leaflet-container', '.map', '.quick-create-wrapper'] : []
  )

  const grayColor = getDefaultGrayColor(dataStore && dataStore.markerColors)
  const effectiveSelectedId = selectedId != null ? selectedId : (grayColor ? grayColor.id : null)

  const originalColorIdRef = useRef(effectiveSelectedId)
  const originalTransparencyRef = useRef(transparency)

  const handleExpandColorPicker = () => {
    originalColorIdRef.current = effectiveSelectedId
    originalTransparencyRef.current = transparency !== undefined ? transparency : 50

    if (effectiveSelectedId) {
      selectionStore.selectedColor = effectiveSelectedId
    }
    if (transparency !== undefined) {
      selectionStore.selectedTransparency = transparency
    }
    uiStore.isColorPickerExpanded = true
    uiStore.showColorMenuTransparency = hasTransparencyOption
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const selectedColor = dataStore.markerColors.find(item => item.id === selectionStore.selectedColor)
    uiStore.isColorPickerExpanded = false
    if (selectedColor) {
      if (typeof onClick === 'function') {
        onClick(selectedColor.id)
      }
      if (dataStore.recentColors.length > 0 && !dataStore.recentColors.find(item => item && item.id === selectedColor.id)) {
        dataStore.recentColors[0] = selectedColor
      }
    }
    if (typeof onTransparencyChange === 'function' && selectionStore.selectedTransparency !== undefined) {
      onTransparencyChange(selectionStore.selectedTransparency)
    }
  }

  const handleCloseClick = (e) => {
    e.stopPropagation()
    uiStore.isColorPickerExpanded = false
  }

  const handleResetColor = (e) => {
    if (e && e.stopPropagation) e.stopPropagation()
    const origColor = originalColorIdRef.current
    const origTrans = originalTransparencyRef.current !== undefined ? originalTransparencyRef.current : 50

    selectionStore.selectedColor = origColor
    selectionStore.selectedTransparency = origTrans

    if (typeof onClick === 'function') {
      onClick(origColor)
    }
    if (typeof onTransparencyChange === 'function') {
      onTransparencyChange(origTrans)
    }
  }

  return (
    <section ref={colorPickerRef} className='color-picker'>
      <span className='color-picker__label'>{t('COLOR_MENU.RECENT')}</span>
      <ul className='color-picker__list'>
        {
          dataStore.recentColors.length > 0 &&
          dataStore.recentColors.map((color, idx) => (
            <span
              className={classnames({
                'color-picker__item': true,
                selected: effectiveSelectedId === color.id
              })}
              key={idx}
              onClick={() => onClick(color.id)}
              style={{
                backgroundColor: color.active_color,
                borderColor: color.inactive_color
              }}
            />
          ))
        }
        <li className='color-picker__item color-picker__item--plus'>
          <button type='button' className='color-picker__btn' onClick={handleExpandColorPicker}>
            <span className='color-picker__plus' />
          </button>
        </li>
      </ul>
      {uiStore.isColorPickerExpanded && (
        <div className='color-picker__full-pane'>
          <ColorMenu
            handleSubmit={handleSubmit}
            handleCloseClick={handleCloseClick}
            handleResetColor={handleResetColor}
            onTransparencyChange={onTransparencyChange}
            showRecentColors={false}
          />
        </div>
      )}
    </section>
  )
}

export default withTranslation()(inject('dataStore', 'uiStore', 'selectionStore')(observer(ColorPicker)))
